export const translations = {
  fi: {
    // Navigation
    nav: {
      home: "Koti",
      recipes: "Reseptit",
      health: "Terveys",
      whyVegan: "Miksi Veganismi?",
      techniques: "Tekniikat",
      admin: "Ylläpito"
    },
    // Home page
    home: {
      heroTitle: "Rakkautta Vegaaniseen Ruokaan",
      heroSubtitle: "Löydä herkullisia, terveellisiä ja kestäviä reseptejä arkeen ja juhlaan",
      exploreRecipes: "Tutustu Resepteihin",
      learnMore: "Lue Lisää",
      featuredRecipes: "Suositut Reseptit",
      categories: {
        express: "Pikavalmistus",
        guests: "Vieraille",
        casual: "Arkinen"
      },
      whyVeganSection: {
        title: "Miksi Valitsemme Veganismin",
        animalWelfare: "Eläinten Hyvinvointi",
        animalWelfareDesc: "Kunnioitamme kaikkia eläviä olentoja",
        ecology: "Ekologia",
        ecologyDesc: "Suojelemme planeettaamme kestävillä valinnoilla",
        health: "Terveys",
        healthDesc: "Ravitsevaa ruokaa kehollesi"
      }
    },
    // Recipes page
    recipes: {
      title: "Reseptit",
      searchPlaceholder: "Etsi reseptejä...",
      allCategories: "Kaikki",
      express: "Pikavalmistus",
      guests: "Vieraille",
      casual: "Arkinen",
      noRecipes: "Reseptejä ei löytynyt",
      minutes: "min",
      servings: "annosta",
      // Course types
      courseType: "Ruokalaji",
      allCourses: "Kaikki ruokalajit",
      appetizer: "Alkupala",
      main: "Pääruoka",
      dessert: "Jälkiruoka",
      snack: "Välipala"
    },
    // Recipe detail
    recipeDetail: {
      ingredients: "Ainekset",
      instructions: "Ohjeet",
      prepTime: "Valmistusaika",
      cookTime: "Kypsennysaika",
      servings: "Annokset",
      backToRecipes: "Takaisin Resepteihin"
    },
    // Health page
    health: {
      title: "Terveys ja Veganismi",
      intro: "Vegaaninen ruokavalio tarjoaa monia terveyshyötyjä, kun se toteutetaan oikein."
    },
    // Why Vegan page
    whyVegan: {
      title: "Miksi Veganismi?",
      intro: "Valitsemme veganismin eläinten hyvinvoinnin ja ekologisten syiden vuoksi.",
      animalWelfare: {
        title: "Eläinten Hyvinvointi",
        content: "Vegaanisena emme osallistu eläinten hyväksikäyttöön. Jokainen elävä olento ansaitsee kunnioituksen ja oikeuden elää vapaana."
      },
      ecology: {
        title: "Ekologiset Syyt",
        content: "Eläintuotanto on yksi suurimmista kasvihuonepäästöjen lähteistä. Kasvisruokavalio vähentää merkittävästi hiilijalanjälkeämme."
      }
    },
    // Techniques page
    techniques: {
      title: "Vegaaniset Ruoanlaittotekniikat",
      intro: "Opi vegaanisen ruoanlaiton perusteet ja edistyneet tekniikat."
    },
    // Admin
    admin: {
      login: "Kirjaudu Sisään",
      username: "Käyttäjätunnus",
      password: "Salasana",
      loginButton: "Kirjaudu",
      dashboard: "Hallintapaneeli",
      addRecipe: "Lisää Resepti",
      editRecipe: "Muokkaa Reseptiä",
      deleteRecipe: "Poista Resepti",
      save: "Tallenna",
      cancel: "Peruuta",
      logout: "Kirjaudu Ulos",
      recipeTitle: "Otsikko",
      recipeDescription: "Kuvaus",
      recipeIngredients: "Ainekset",
      recipeInstructions: "Ohjeet",
      recipeCategory: "Kategoria",
      recipePrepTime: "Valmistusaika (min)",
      recipeCookTime: "Kypsennysaika (min)",
      recipeServings: "Annokset",
      recipeImage: "Kuva",
      uploadImage: "Lataa Kuva",
      confirmDelete: "Haluatko varmasti poistaa tämän reseptin?"
    },
    // Footer
    footer: {
      tagline: "Herkullisia vegaanisia reseptejä kaikille",
      navigation: "Navigointi",
      contact: "Yhteystiedot",
      followUs: "Seuraa Meitä",
      rights: "Kaikki oikeudet pidätetään"
    },
    // Common
    common: {
      loading: "Ladataan...",
      error: "Virhe tapahtui",
      success: "Onnistui!"
    }
  },
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      recipes: "Recettes",
      health: "Santé",
      whyVegan: "Pourquoi Végan?",
      techniques: "Techniques",
      admin: "Admin"
    },
    // Home page
    home: {
      heroTitle: "L'Amour de la Cuisine Végane",
      heroSubtitle: "Découvrez des recettes délicieuses, saines et durables pour tous les jours",
      exploreRecipes: "Explorer les Recettes",
      learnMore: "En Savoir Plus",
      featuredRecipes: "Recettes Vedettes",
      categories: {
        express: "Express",
        guests: "Pour Invités",
        casual: "Quotidien"
      },
      whyVeganSection: {
        title: "Pourquoi Nous Choisissons le Véganisme",
        animalWelfare: "Bien-être Animal",
        animalWelfareDesc: "Nous respectons tous les êtres vivants",
        ecology: "Écologie",
        ecologyDesc: "Nous protégeons notre planète par des choix durables",
        health: "Santé",
        healthDesc: "Une alimentation nutritive pour votre corps"
      }
    },
    // Recipes page
    recipes: {
      title: "Recettes",
      searchPlaceholder: "Rechercher des recettes...",
      allCategories: "Toutes",
      express: "Express",
      guests: "Pour Invités",
      casual: "Quotidien",
      noRecipes: "Aucune recette trouvée",
      minutes: "min",
      servings: "portions",
      // Course types
      courseType: "Type de plat",
      allCourses: "Tous les plats",
      appetizer: "Entrée",
      main: "Plat principal",
      dessert: "Dessert",
      snack: "Collation"
    },
    // Recipe detail
    recipeDetail: {
      ingredients: "Ingrédients",
      instructions: "Instructions",
      prepTime: "Temps de préparation",
      cookTime: "Temps de cuisson",
      servings: "Portions",
      backToRecipes: "Retour aux Recettes"
    },
    // Health page
    health: {
      title: "Santé et Véganisme",
      intro: "Un régime végétalien offre de nombreux avantages pour la santé lorsqu'il est bien mené."
    },
    // Why Vegan page
    whyVegan: {
      title: "Pourquoi le Véganisme?",
      intro: "Nous choisissons le véganisme pour le bien-être animal et des raisons écologiques.",
      animalWelfare: {
        title: "Bien-être Animal",
        content: "En tant que végans, nous ne participons pas à l'exploitation animale. Chaque être vivant mérite le respect et le droit de vivre libre."
      },
      ecology: {
        title: "Raisons Écologiques",
        content: "L'élevage est l'une des plus grandes sources d'émissions de gaz à effet de serre. Un régime végétal réduit considérablement notre empreinte carbone."
      }
    },
    // Techniques page
    techniques: {
      title: "Techniques de Cuisine Végane",
      intro: "Apprenez les bases et les techniques avancées de la cuisine végétalienne."
    },
    // Admin
    admin: {
      login: "Connexion",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      loginButton: "Se Connecter",
      dashboard: "Tableau de Bord",
      addRecipe: "Ajouter une Recette",
      editRecipe: "Modifier la Recette",
      deleteRecipe: "Supprimer la Recette",
      save: "Enregistrer",
      cancel: "Annuler",
      logout: "Déconnexion",
      recipeTitle: "Titre",
      recipeDescription: "Description",
      recipeIngredients: "Ingrédients",
      recipeInstructions: "Instructions",
      recipeCategory: "Catégorie",
      recipePrepTime: "Temps de prép. (min)",
      recipeCookTime: "Temps de cuisson (min)",
      recipeServings: "Portions",
      recipeImage: "Image",
      uploadImage: "Télécharger Image",
      confirmDelete: "Voulez-vous vraiment supprimer cette recette?"
    },
    // Footer
    footer: {
      tagline: "Délicieuses recettes véganes pour tous",
      navigation: "Navigation",
      contact: "Contact",
      followUs: "Suivez-nous",
      rights: "Tous droits réservés"
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Succès!"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      recipes: "Recipes",
      health: "Health",
      whyVegan: "Why Vegan?",
      techniques: "Techniques",
      admin: "Admin"
    },
    // Home page
    home: {
      heroTitle: "Love for Vegan Food",
      heroSubtitle: "Discover delicious, healthy, and sustainable recipes for everyday cooking",
      exploreRecipes: "Explore Recipes",
      learnMore: "Learn More",
      featuredRecipes: "Featured Recipes",
      categories: {
        express: "Express",
        guests: "For Guests",
        casual: "Casual"
      },
      whyVeganSection: {
        title: "Why We Choose Veganism",
        animalWelfare: "Animal Welfare",
        animalWelfareDesc: "We respect all living beings",
        ecology: "Ecology",
        ecologyDesc: "We protect our planet with sustainable choices",
        health: "Health",
        healthDesc: "Nutritious food for your body"
      }
    },
    // Recipes page
    recipes: {
      title: "Recipes",
      searchPlaceholder: "Search recipes...",
      allCategories: "All",
      express: "Express",
      guests: "For Guests",
      casual: "Casual",
      noRecipes: "No recipes found",
      minutes: "min",
      servings: "servings",
      // Course types
      courseType: "Course",
      allCourses: "All courses",
      appetizer: "Appetizer",
      main: "Main course",
      dessert: "Dessert",
      snack: "Snack"
    },
    // Recipe detail
    recipeDetail: {
      ingredients: "Ingredients",
      instructions: "Instructions",
      prepTime: "Prep Time",
      cookTime: "Cook Time",
      servings: "Servings",
      backToRecipes: "Back to Recipes"
    },
    // Health page
    health: {
      title: "Health and Veganism",
      intro: "A vegan diet offers many health benefits when done correctly."
    },
    // Why Vegan page
    whyVegan: {
      title: "Why Veganism?",
      intro: "We choose veganism for animal welfare and ecological reasons.",
      animalWelfare: {
        title: "Animal Welfare",
        content: "As vegans, we don't participate in animal exploitation. Every living being deserves respect and the right to live free."
      },
      ecology: {
        title: "Ecological Reasons",
        content: "Animal agriculture is one of the largest sources of greenhouse gas emissions. A plant-based diet significantly reduces our carbon footprint."
      }
    },
    // Techniques page
    techniques: {
      title: "Vegan Cooking Techniques",
      intro: "Learn the basics and advanced techniques of vegan cooking."
    },
    // Admin
    admin: {
      login: "Login",
      username: "Username",
      password: "Password",
      loginButton: "Log In",
      dashboard: "Dashboard",
      addRecipe: "Add Recipe",
      editRecipe: "Edit Recipe",
      deleteRecipe: "Delete Recipe",
      save: "Save",
      cancel: "Cancel",
      logout: "Log Out",
      recipeTitle: "Title",
      recipeDescription: "Description",
      recipeIngredients: "Ingredients",
      recipeInstructions: "Instructions",
      recipeCategory: "Category",
      recipePrepTime: "Prep Time (min)",
      recipeCookTime: "Cook Time (min)",
      recipeServings: "Servings",
      recipeImage: "Image",
      uploadImage: "Upload Image",
      confirmDelete: "Are you sure you want to delete this recipe?"
    },
    // Footer
    footer: {
      tagline: "Delicious vegan recipes for everyone",
      navigation: "Navigation",
      contact: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved"
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success!"
    }
  }
};

export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};
